import { useEffect, useState } from "react";

export type RecentItem = {
  id: string;
  title: string;
  route: string;
  kind: "parent" | "child";
  tagline?: string;
  iconKey?: string; // string key, not JSX
};

const KEY = "recentVisitedDashboards";
const MAX = 4;

export function useRecentVisited() {
  const [recent, setRecent] = useState<RecentItem[]>([]);
  useEffect(() => { try { const r = localStorage.getItem(KEY); if (r) setRecent(JSON.parse(r)); } catch {} }, []);
  const addVisited = (item: RecentItem) => {
    setRecent(prev => {
      const dedup = prev.filter(p => !(p.route === item.route && p.kind === item.kind));
      const updated = [item, ...dedup].slice(0, MAX);
      localStorage.setItem(KEY, JSON.stringify(updated));
      return updated;
    });
  };
  return { recent, addVisited };
}